<div class="container-fluid">
    <!-- Barra de acciones -->
    <div class="d-flex justify-content-between align-items-center mb-3">
        <!-- Búsqueda -->
        <div class="input-group w-25">
            <span class="input-group-text"><i class="fa fa-search"></i></span>
            <input type="text" class="form-control" placeholder="Buscar..." name="searchTerm" [(ngModel)]="service.searchTerm">
        </div>

        <!-- Botones de acciones -->
        <div class="d-flex gap-2 rtl-dropdown">
            <!--<button class="btn btn-outline-primary">
                <i class="bi bi-sliders"></i> Configurar vista
            </button>
            <button class="btn btn-outline-success">
                <i class="bi bi-download"></i> Exportar
            </button>

            <div class="input-group mb-3">
                <select class="col-12 form-select" id="showColumns" aria-describedby="button-addon2">
                    <option [ngValue]="null" disabled selected>Columnas</option>
                    <option *ngFor="let column of configurationTable.columns" [value]="column.id">{{ column.title }}</option>
                </select>
                <button class="btn btn-outline-primary" type="button" id="button-addon2">Button</button>
            </div>-->
            <div class="btn-group" ngbDropdown>
                <button class="btn btn-success dropdown-toggle" type="button"
                        ngbDropdownToggle>
                    <span *ngIf="active">Activos</span>
                    <span *ngIf="!active">Inactivos</span>
                </button>
                <ul class="dropdown-menu dropdown-block" ngbDropdownMenu style="z-index: 1000;">
                    <li *ngIf="!active" (click)="changeStatus(1);">
                        <a class="dropdown-item" ngbDropdownItem>Activos</a>
                    </li>
                    <li *ngIf="active" (click)="changeStatus(0);">
                        <a class="dropdown-item" ngbDropdownItem>Inactivos</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <!-- Tabla responsiva -->
    <div class="table-responsive custom-scrollbar" style="max-height: 70vh; overflow-y: auto;">
        <table class="table table-hover table-bordered align-middle">
            <!-- Header con categorías -->
            <thead class="table-light text-center align-middle">
                <tr>
                    <th rowspan="2" style="position: sticky; left: 0; top: 0; z-index: 4; background: #f8f9fa; min-width: 120px; vertical-align: middle;">Placas</th>
                    <th rowspan="2" style="position: sticky; left: 120px; top: 0; z-index: 4; background: #f8f9fa; min-width: 90px; vertical-align: middle;">NIV</th>
                    <th rowspan="2" style="position: sticky; left: 210px; top: 0; z-index: 4; background: #f8f9fa; min-width: 150px; vertical-align: middle;">N/S</th>
                    <th *ngFor="let column of categoriesCountArray" [attr.colspan]="column.number"
                        style="position: sticky; top: 0; z-index: 2; background: #f8f9fa;">
                        <span class="f-light f-w-600">{{ column.key }}</span>
                    </th>
                </tr>
                <!-- Sub-headers -->
                <tr>
                    <ng-container *ngFor="let col of keys">
                        <ng-container *ngFor="let tb of configurationTable.columns">
                            <th *ngIf="tb.id == col">
                                <span class="f-light f-w-600">{{ tb.title }}</span>
                            </th>
                        </ng-container>

                    </ng-container>
                </tr>
            </thead>
            <tbody *ngIf="(service.loading$ | async)">
                <tr>
                    <td class="datatable-empty text-center" [attr.colspan]="columns.length + 1">Cargando información, por favor espera...</td>
                </tr>
            </tbody>
            <!-- Body -->
            <tbody *ngIf="!(service.loading$ | async)">
                <tr *ngFor="let item of dataTable">
                    <td style="position: sticky; left: 0; z-index: 2; background: white; min-width: 120px; font-weight: 600;">
                        <p class="f-light f-w-600">{{ item['vehicles.plates'] }}</p>
                    </td>
                    <td style="position: sticky; left: 120px; z-index: 2; background: white; min-width: 90px; font-weight: 600;">
                        <p class="f-light f-w-600">{{ item['vehicles.niv'] }}</p>
                    </td>
                    <td style="position: sticky; left: 210px; z-index: 2; background: white; min-width: 150px; font-weight: 600;">
                        <p class="f-light f-w-600">{{ item['vehicles.ns'] }}</p>
                    </td>
                    <!--<ng-container *ngFor="let column of columns">
                        <td *ngIf="item[column.id]">
                            <p class="f-light">{{ item[column.id] }}</p>
                        </td>
                    </ng-container>-->
                    <ng-container *ngIf="keys.length > 0">
                        <td *ngFor="let column of keys">
                            <p class="f-light">{{ item[column] }}</p>
                        </td>
                    </ng-container>
                </tr>
                <!-- Muestra un mensaje si no hay datos -->
                <tr *ngIf="dataTable.length === 0">
                    <td class="datatable-empty" [attr.colspan]="columns.length + 1">Sin registros</td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="d-flex justify-content-between p-2">
        <select class="form-select" style="width: auto" name="pageSize" [(ngModel)]="service.pageSize">
            <option [ngValue]="10">10 registros por página</option>
            <option [ngValue]="25">25 registros por página</option>
            <option [ngValue]="50">50 registros por página</option>
            <option [ngValue]="100">100 registros por página</option>
        </select>
        <ngb-pagination [collectionSize]="(total$ | async)!" [(page)]="service.page"
                        [pageSize]="service.pageSize"> </ngb-pagination>
    </div>

</div>
<!--<app-customize-table></app-customize-table>-->










<!--<app-table [configurationTable]="configurationTable"></app-table>-->
